import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Text } from "../Text";
import { useIsMobileDimension } from "../hooks/useGetDimensionGroup";
import { Link } from "../Link";
import { ChevronLeftIcon } from "../icons";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var BreadCrumbs = /*#__PURE__*/memo(function (_ref) {
  var path = _ref.path,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'BreadCrumbs' : _ref$testName;
  var isMobileDimension = useIsMobileDimension();
  var lastItemIndex = path.length - 1;
  if (isMobileDimension) {
    var backLink = path[lastItemIndex - 1];
    return /*#__PURE__*/React.createElement("div", {
      className: cn('back-link'),
      "data-omponent": testName,
      "data-t-id": "src-BreadCrumbs"
    }, (backLink === null || backLink === void 0 ? void 0 : backLink.url) && /*#__PURE__*/React.createElement(Link, {
      href: backLink.url,
      icon: /*#__PURE__*/React.createElement(ChevronLeftIcon, null),
      isNoUnderline: true,
      size: "size5-r-l",
      variant: "light"
    }, backLink.label));
  }
  return /*#__PURE__*/React.createElement("ul", {
    className: cn('list'),
    "data-component": testName,
    "data-name": "BreadCrumbs",
    itemScope: true,
    itemType: "http://schema.org/BreadcrumbList"
  }, path.map(function (pathItem, i) {
    var isLast = i === lastItemIndex;
    return /*#__PURE__*/React.createElement("li", {
      className: cn('list-item'),
      itemProp: "itemListElement",
      itemScope: true,
      itemType: "http://schema.org/ListItem",
      key: pathItem.label
    }, isLast && /*#__PURE__*/React.createElement(Text, {
      color: "textIconElementPrimary",
      extraAttributes: {
        itemProp: 'name'
      },
      size: "size6-r"
    }, pathItem.label), !isLast && pathItem.url && /*#__PURE__*/React.createElement(Link, {
      extraAttributes: {
        itemProp: 'item'
      },
      href: pathItem.url,
      isNoUnderline: true,
      size: "size6-r",
      variant: "inherit"
    }, pathItem.label), /*#__PURE__*/React.createElement("meta", {
      content: String(i + 1),
      itemProp: "position"
    }));
  }));
});
BreadCrumbs.displayName = BreadCrumbs.name;